import { text, textarea } from '../../themes/settingFields';
import { element } from './definition';
import { look, paint, space } from './styleTokens';

// The three that fit nowhere else. Two of them carry almost nothing, because their whole content is
// their size and their colour and those already live in the Styles tab — spelling a height as a prop
// as well would give one thing two owners, and the merchant would find out which one wins by accident.

/** Deliberate empty space between two elements; how much is a style, not a setting. */
export const spacerElement = element('spacer', {
  label: 'Spacer',
  description: 'Deliberate empty space between two elements. Set how much of it in Styles.',
  category: 'Other',
  icon: 'move-vertical',
  props: [],
  defaults: { props: {}, styles: look({ display: 'block', width: '100%', height: '48px' }) }
});

/**
 * A rule across the page, optionally with a word set into the middle of it.
 *
 * LightFunnels offers no setting at all here — its rule is a box whose height, colour and dash live
 * entirely in Styles, and it exposes no shape or ornament we are missing. `label` is ours and stays,
 * because a saved page may already carry a word in one, and it draws nothing until a merchant types it.
 */
export const dividerElement = element('divider', {
  label: 'Divider',
  description: 'A rule across the page, with an optional word set into the middle of it.',
  category: 'Other',
  icon: 'minus',
  props: [text('label', 'Word in the middle')],
  defaults: {
    props: { label: '' },
    styles: look({
      display: 'block', width: '100%', maxWidth: '100%', height: '1px', backgroundColor: paint('border'),
      marginTop: space('sm'), marginBottom: space('sm')
    })
  }
});

/** The escape hatch: markup the merchant pastes in for a widget or an embed. */
export const customHtmlElement = element('custom-html', {
  label: 'Custom HTML',
  description: 'Markup you paste in yourself for a widget or an embed, when nothing here does the job.',
  category: 'Other',
  icon: 'code',
  // LightFunnels lands this holding one visible span, so a merchant can see where the block sits before
  // they have pasted anything into it. Ours lands holding the same markup, word for word.
  props: [textarea('html', 'HTML')],
  defaults: {
    props: { html: '<span>custom html</span>' },
    styles: look({ display: 'block', width: '100%', minHeight: '40px' })
  }
});
